module.exports = __webpack_public_path__ + "media/images/body-bgr-left-7e52ed3736f4309673b72f1a93548f3b.png";